<template>
  <SimulationTemplate v-if="form !== null" :form="form" />
</template>

<script>
import SimulationTemplate from '@/components/Shared/Simulation/SimulationTemplate.vue'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeLoginLp } from '@/mixins/setDrawerTypeLoginLp'
import { setToolBarTypeLoginLp } from '@/mixins/setToolBarTypeLoginLp'
import { mapActions } from 'vuex'
import { modes } from '@/vuex/modules/simulation/constants'
import {
  updateFormFactory,
  SimulationPlanRepository,
} from '@/models/Simulation'

export default {
  name: 'SimulationEdit',
  components: {
    SimulationTemplate,
  },
  mixins: [accountInitializer, setDrawerTypeLoginLp, setToolBarTypeLoginLp],
  data() {
    return {
      form: null,
    }
  },
  async beforeRouteUpdate(to, from, next) {
    next()
    await this.getFormData()
    this.setInitialStep()
  },
  async created() {
    await this.getFormData()
    if (this.form.basicSetting.isReadOnly) {
      this.mode(modes.READONLY)
    } else {
      this.mode(modes.EDIT)
    }
    this.setInitialStep()
  },
  methods: {
    ...mapActions('simulation', {
      mode: 'MODE',
      setStep: 'SET_STEP',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    setInitialStep() {
      const initialStep = this.$route.params.initialStep
      if (initialStep) {
        this.setStep(initialStep)
      }
    },
    async getFormData() {
      const simulationId = this.$route.params.simulationId
      const simulationPlan = await SimulationPlanRepository.findById(
        simulationId,
      )
      this.form = await updateFormFactory(simulationPlan)
    },
  },
}
</script>

<style></style>
